import Lenis from '@studio-freight/lenis'
import { ScrollTrigger } from "gsap/ScrollTrigger"

let lenis = null;

export const initLenis = (onScrollCallback = null) => {
    lenis = new Lenis({
        duration: 1.6,
        lerp: 0.05,
        easing: t => 1 - Math.pow(1 - t, 3),
        smooth: true,
        wheelMultiplier: 1,
        touchMultiplier: 1,
        normalizeWheel: true,
        autoRaf: false,
    });

    ScrollTrigger.scrollerProxy(document.body, {
        scrollTop(value) {
            return arguments.length ? lenis.scrollTo(value) : lenis.scroll;
        },
        getBoundingClientRect() {
            return {
                top: 0,
                left: 0,
                width: window.innerWidth,
                height: window.innerHeight
            };
        },
        pinType: 'fixed'
    });

    const raf = (time) => {
        lenis.raf(time);
        ScrollTrigger.update();
        if (typeof onScrollCallback === 'function') {
            onScrollCallback({
                scroll: lenis.scroll,
                velocity: lenis.velocity,
                direction: lenis.direction
            });
        }
        requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
};

export const scrollTo = (target, options = {}) => {
    if (lenis) {
        lenis.scrollTo(target, options);
    }
};


export { lenis };